import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';

import Language from '../../helpers/Language';
import { FAQCategory } from '../../interfaces/FAQ';
import BackendRepositoryRemote from '../BackendRepositoryRemote';

const repository = new BackendRepositoryRemote();

export const getFaqQueryConfig = (hashId?: string): UseQueryOptions<FAQCategory[]> => {
  const language = Language.getLanguage();

  return {
    queryKey: ['FAQ', hashId, language],
    queryFn: hashId ? () => repository.getFAQ(hashId, language) : skipToken,
    gcTime: Infinity,
  };
};

export const useGetFAQQuery = (hashId?: string) => {
  const { data, isLoading } = useQuery<FAQCategory[]>({
    ...getFaqQueryConfig(hashId),
    staleTime: Infinity,
  });

  const sanitizedData: FAQCategory[] | undefined = data?.map((faq) => {
    const categories = faq.category.split(',');

    return {
      ...faq,
      category: categories[categories.length - 1].trim()
    };
  });

  return { faq: sanitizedData, isFAQLoading: isLoading };
};
